const state = {
  userInfo: {},
  goodsInfo: {},
  gameInfo: {}
};

const mutations = {
  CHANGE_STATE: (state, obj) => {
    state = Object.assign(state, obj);
  },
};

const actions = {
  
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
